import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { GlobalContext } from '../../../contexts/GlobalContext';
import ProviderSidebar from './ProviderSidebar';
import AnotherMenuCss from '../../../assets/css/components/admin/menus/AnotherMenuCss';

const ProviderSidebarWrapper = () => {
  const globalContext = useContext(GlobalContext);

  const closeMenuSidebar = (e) => {
    e.preventDefault();
    globalContext.setStatusMenu(false);
  };

  return (
    <AnotherMenuCss.contSidebar active={globalContext.statusMenu}>
      <AnotherMenuCss.cont active={globalContext.statusMenu}>
        <AnotherMenuCss.header active={globalContext.statusMenu}>
          <p>PANEL DE PROVEEDOR</p>
          <button onClick={(e) => closeMenuSidebar(e)}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </AnotherMenuCss.header>
        <ProviderSidebar />
      </AnotherMenuCss.cont>
    </AnotherMenuCss.contSidebar>
  );
};

export default ProviderSidebarWrapper; 